var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationSzare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2886_6281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.68352 0 0 2.68376 0 6C0 9.31648 2.68376 12 6 12C9.31648 12 12 9.31624 12 6C12 2.68352 9.31622 0 6 0ZM6 11.0625C3.20173 11.0625 0.9375 8.79809 0.9375 6C0.9375 3.20173 3.20191 0.9375 6 0.9375C8.79827 0.9375 11.0625 3.20191 11.0625 6C11.0625 8.79827 8.79806 11.0625 6 11.0625Z",
    fill: "#7F7C85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5.02332C5.74111 5.02332 5.53125 5.23317 5.53125 5.49207V8.51065C5.53125 8.76954 5.74111 8.9794 6 8.9794C6.25889 8.9794 6.46875 8.76952 6.46875 8.51063V5.49207C6.46875 5.23317 6.25889 5.02332 6 5.02332Z",
    fill: "#7F7C85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4.44934C6.34949 4.44934 6.63281 4.16602 6.63281 3.81653C6.63281 3.46704 6.34949 3.18372 6 3.18372C5.65051 3.18372 5.36719 3.46704 5.36719 3.81653C5.36719 4.16602 5.65051 4.44934 6 4.44934Z",
    fill: "#7F7C85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2886_6281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationSzare);
export default __webpack_public_path__ + "static/media/Information-szare.20dea40aabf229572a21728ecbc7906f.svg";
export { ForwardRef as ReactComponent };